import React, { useState, useEffect, useRef } from "react";
import CountUp from "react-countup";

const CounterSection = () => {
  const [startCount, setStartCount] = useState(false);
  const sectionRef = useRef(null);  // Use ref instead of document.getElementById

  useEffect(() => {
    const handleScroll = () => {
      const section = sectionRef.current;
      if (section) {  // Check if section is not null
        const sectionTop = section.getBoundingClientRect().top;
        const triggerPoint = window.innerHeight - 100; // Adjust this value as needed

        if (sectionTop < triggerPoint) {
          setStartCount(true);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div ref={sectionRef} id="counter-section" className="text-center py-10">
      <div className="grid grid-cols-3 gap-6">
        <div>
          <h2 className="text-4xl font-bold text-logo">
            {startCount ? <CountUp end={844} duration={3} /> : "0"}
          </h2>
          <p className="text-xl font-medium">Happy Clients</p>
        </div>
        <div>
          <h2 className="text-4xl font-bold text-logo">
            {startCount ? <CountUp end={1240} duration={3} /> : "0"}
          </h2>
          <p className="text-xl font-medium">Project Done</p>
        </div>
        <div>
          <h2 className="text-4xl font-bold text-logo">
            {startCount ? <CountUp end={1541} duration={3} /> : "0"}
          </h2>
          <p className="text-xl font-medium">Day Of Work</p>
        </div>
      </div>
    </div>
  );
};

export default CounterSection;
